import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";
import multiguard from "vue-router-multiguard";
import axios from "axios";
import http from "../utils/http-common";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import i18n from "@/i18n"
import { DEFAULT_SORT_JSON } from '../store/constants/userInfoSortJsonDefault'

Vue.use(VueRouter);

function methodRecall() { // main.js, mutations.js, actions.js, index.js(router) 공유
  return new Promise((resolve, reject) => {
    // BE에 access token 저장 후 Promise 객체 return (이전 method 재호출을 위해)
    if (!store.state.isMethodRecalling) {
      // methodRecall이 호출되고 새로운 token을 갱신 및 저장 중인 상태가 아니라면
      console.log("setIsMethodRecalling true");
      store.commit('setIsMethodRecalling', true); // isMethodRecalling을 true로 변경(새로운 token을 갱신 및 저장 중인 상태)
      console.log('refresh_token', store.state.refresh_token)
      if (store.state.user_info.user_type === 'google') {
        axios
        .post('https://oauth2.googleapis.com/token', {
          // refresh token으로 새로운 access token 갱신
          client_id: process.env.VUE_APP_CLIENT_ID,
          client_secret: process.env.VUE_APP_CLIENT_SECRET,
          refresh_token: store.state.refresh_token,
          grant_type: 'refresh_token',
        })
        .then((res) => {
          // refresh_token이 만료되기 전이므로 정상적으로 access_token을 갱신
          console.log('refresh_token이 만료되기 전이므로 정상적으로 access_token을 갱신');
          console.log(res);
          http
          .get('account/update-token/', { headers: { Authorization: 'Bearer ' + res.data.access_token } }) // BE에 새로 갱신한 access token 정보 저장
          .then((res1) => {
            console.log(res1);
            console.log('BE에 새로 갱신한 access token 정보 저장');
            store.commit('setAccessToken', res.data.access_token); // store에 새로 갱신한 access token 저장
            console.log('setIsMethodRecalling false');
            store.commit('setIsMethodRecalling', false); // isMethodRecalling을 false로 변경(새로운 token을 갱신 및 저장 중이지 않은 상태)
            setTimeout(() => {
              resolve('access token 갱신 및 저장 완료 -> method 재호출 1');
            }, 1000);
          })
          .catch((err1) => {
            console.log('BE에 access token 저장 실패');
            console.log(err1);
            console.log(err1.response);
            setTimeout(() => {
              reject(0); // BE에 access token 저장 실패
            }, 1);
          });
        })
        .catch((err) => {
          // refresh_token도 만료되어 사용자에게 재로그인 요청
          console.log("refresh token 만료(access token 갱신 실패)");
          console.log(err);
          console.log(err.response);
          setTimeout(() => {
            reject(1); // refresh token 만료(access token 갱신 실패)
          }, 1);
        });
      } else if (store.state.user_info.user_type === 'django' || store.state.user_info.user_type === 'django-prosecution') {
        http
        .get('account/update-token-recolumn/', { headers: { Authorization: 'Bearer ' + store.state.refresh_token } }) // BE에서 새로운 access token 받아오기
        .then(res => {
          console.log('update-token-recolumn res', res)
          // store.commit('setRefreshToken', res.data.refresh_token); // store에 새로 갱신한 refresh token 저장
          if (res.data.access_token) { // access token이 있다면(null이 아니라면)
            store.commit('setAccessToken', res.data.access_token); // store에 새로 갱신한 access token 저장
          }
          console.log("setIsMethodRecalling false");
          store.commit('setIsMethodRecalling', false); // isMethodRecalling을 false로 변경(새로운 token을 갱신 및 저장 중이지 않은 상태)
          setTimeout(() => {
            resolve("access token 갱신 및 저장 완료 -> method 재호출 2");
          }, 1000);
        })
        .catch((err) => {
          // refresh_token도 만료되어 사용자에게 재로그인 요청
          console.log("refresh token 만료(access token 갱신 실패)");
          console.log(err);
          console.log(err.response);
          setTimeout(() => {
            reject(1); // refresh token 만료(access token 갱신 실패)
          }, 1);
        });
      }
    } else {
      // methodRecall이 호출되고 새로운 token을 갱신 및 저장 중인 상태라면
      setTimeout(() => {
        resolve("access token 갱신 및 저장 완료 -> method 재호출 3");
        console.log("setIsMethodRecalling false");
        store.commit('setIsMethodRecalling', false);
      }, 1000);
    }
  });
}

function disableConsole() {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  // 에러는 확인해야 하므로 console.error는 남겨두는 편이 좋습니다.
}

const onlyAfterLogin = (to, from, next) => {
  console.log('onlyAfterLogin', to, from, next)
  if (store.getters.isLoggedIn === false) {
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>로그인해 주세요.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next({ path: "/", });
  } else {
    if (Object.keys(store.state.user_info).length > 0) {
      // production 환경 && super_admin이 아니면 모든 콘솔 로그를 빈 함수로 덮어씁니다.
      if (process.env.NODE_ENV === "production" && store.state.user_info.organization_permission !== 'super_admin') {
        disableConsole()
      }
      next();
    }
    else {
      // 유저 정보 호출 및 저장
      http
      .get('account/user/', { headers: { Authorization: 'Bearer ' + store.state.access_token } })
      .then(res => {
        console.log('getUserInfo res', res)
        if (!res.data.sort_json) {
          res.data.sort_json = { ...DEFAULT_SORT_JSON }
        }
        if (!res.data.language) {
          res.data.language = 'ko'
        }
        i18n.locale = res.data.language
        i18n.fallbackLocale  = res.data.language
        // 기한 만료 n일 이내인 경우
        if (res.data.license_block >= 0) {
          // 무료체험 계정인 경우
          if (res.data.plan === 'trial') {
            if (res.data.sort_json.expireDateEndDialog || res.data.sort_json.expireDateEndDialog === null || res.data.sort_json.expireDateEndDialog === undefined) {
              res.data.sort_json.expireDateEndDialog = true
            }
            if (res.data.sort_json.expireDateEndAlert || res.data.sort_json.expireDateEndAlert === null || res.data.sort_json.expireDateEndAlert === undefined) {
              res.data.sort_json.expireDateEndAlert = true
            }
          }
          // 엔터프라이즈 계정인 경우
          else {
            res.data.sort_json.expireDateEndDialog = false
            if (res.data.sort_json.expireDateEndAlert || res.data.sort_json.expireDateEndAlert === null || res.data.sort_json.expireDateEndAlert === undefined) {
              res.data.sort_json.expireDateEndAlert = true
            }
          }
        } else {
          res.data.sort_json.expireDateEndDialog = false
          res.data.sort_json.expireDateEndAlert = false
        }
        store.dispatch('updateUserInfo', res.data)
        next();
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        if (err.response && err.response.status === 401) { // access token 만료
          methodRecall()
          .then(msg => {
            console.log(msg)
            // method 재호출
            http
            .get('account/user/', { headers: { Authorization: 'Bearer ' + store.state.access_token } })
            .then(res => {
              console.log('getUserInfo res', res)
              if (!res.data.sort_json) {
                res.data.sort_json = { ...DEFAULT_SORT_JSON }
              }
              if (!res.data.language) {
                res.data.language = 'ko'
              }
              i18n.locale = res.data.language
              i18n.fallbackLocale  = res.data.language
              // 기한 만료 n일 이내인 경우
              if (res.data.license_block >= 0) {
                // 무료체험 계정인 경우
                if (res.data.plan === 'trial') {
                  if (res.data.sort_json.expireDateEndDialog || res.data.sort_json.expireDateEndDialog === null || res.data.sort_json.expireDateEndDialog === undefined) {
                    res.data.sort_json.expireDateEndDialog = true
                  }
                  if (res.data.sort_json.expireDateEndAlert || res.data.sort_json.expireDateEndAlert === null || res.data.sort_json.expireDateEndAlert === undefined) {
                    res.data.sort_json.expireDateEndAlert = true
                  }
                }
                // 엔터프라이즈 계정인 경우
                else {
                  res.data.sort_json.expireDateEndDialog = false
                  if (res.data.sort_json.expireDateEndAlert || res.data.sort_json.expireDateEndAlert === null || res.data.sort_json.expireDateEndAlert === undefined) {
                    res.data.sort_json.expireDateEndAlert = true
                  }
                }
              } else {
                res.data.sort_json.expireDateEndDialog = false
                res.data.sort_json.expireDateEndAlert = false
              }
              store.dispatch('updateUserInfo', res.data)
              next();
            })
          })
          .catch(err_msg => {
            console.log(err_msg)
            store.commit('setOverlay', false)
            store.commit('setOverlayText', '')
            if (err_msg === 0) {
              console.log('BE에 access token 저장 실패')
            } else { // err_msg === 1
              console.log('refresh token 만료(access token 갱신 실패)')
              // store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
              store.commit('logout')
              next('/');
            }
          })
        } else {
          Swal.mixin({
            toast: true,
            showClass: { popup: 'animate__animated animate__fadeInDown' },
            hideClass: { popup: 'animate__animated animate__fadeOutUp' },
            position: 'top',
            showConfirmButton: false,
            timer: store.getters.toastTimer,
            timerProgressBar: false,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          }).fire({
            icon: "warning",
            iconColor: "#ffc107",
            title: "<div style='font-size: 16px; color: #0D0E17'>데이터를 불러오는 데 실패했습니다.<div>",
            width: store.getters.toastWidth,
            background: store.getters.toastBgColor
          })
          store.commit('logout')
          next('/');
        }
      })
    }
  }
};
const onlyBeforeLogin = (to, from, next) => {
  console.log('onlyBeforeLogin', to, from, next)
  if (store.getters.isLoggedIn === true) {
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>로그인한 사용자는 이용할 수 없는 페이지입니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next({ path: "/", });
  } else {
    next();
  }
};
const onlyOwner = (to, from, next) => {
  console.log('onlyOwner', to, from, next)
  if (store.state.current_project.level < 3) {
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>권한이 없습니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next("/workspace");
  } else {
    next();
  }
};
const onlySuperAdmin = (to, from, next) => {
  console.log('onlySuperAdmin', to, from, next)
  if (store.state.user_info.organization_permission !== 'super_admin') {
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>권한이 없습니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next("/workspace");
  } else {
    next();
  }
};
const redirectWorkspace = (to, from, next) => {
  console.log('redirectWorkspace', to, from, next)
  if (store.getters.isLoggedIn === true) {
    // production 환경 && super_admin이 아니면 모든 콘솔 로그를 빈 함수로 덮어씁니다.
    if (process.env.NODE_ENV === "production" && store.state.user_info.organization_permission !== 'super_admin') {
      disableConsole()
    }
    next({ path: "/workspace", });
  } else {
    disableConsole()
    next();
  }
};

const checkPjt = (to, from, next) => {
  console.log('checkPjt', to, from, next)
  if ('pk' in to.params) {
    console.log('setCurrentProjectPk', Number(to.params.pk))
    store.commit('setCurrentProjectPk', Number(to.params.pk))
    // 프로젝트 정보 호출 및 저장
    http
    .get(`annotation/get-project-list/${store.state.current_project_pk}/`, { headers: { Authorization: 'Bearer ' + store.state.access_token } })
    .then(res => {
      console.log('get-project-list res', res)
      // 대표 이미지 관련
      if (res.data.icon_url) {
        res.data.icon_url = store.getters.baseUrl + '/media/' + res.data.icon_url
      }
      checkPjtFunction(to, from, next, res)
    })
    .catch(err => {
      console.log(err)
      console.log(err.response)
      if (err.response && err.response.status === 401) { // access token 만료
        methodRecall()
        .then(msg => {
          console.log(msg)
          // method 재호출
          http
          .get(`annotation/get-project-list/${store.state.current_project_pk}/`, { headers: { Authorization: 'Bearer ' + store.state.access_token } })
          .then(res => {
            checkPjtFunction(to, from, next, res)
          })
        })
        .catch(err_msg => {
          console.log(err_msg)
          store.commit('setOverlay', false)
          store.commit('setOverlayText', '')
          if (err_msg === 0) {
            console.log('BE에 access token 저장 실패')
          } else { // err_msg === 1
            console.log('refresh token 만료(access token 갱신 실패)')
            // store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
            store.commit('logout')
            next('/');
          }
        })
      } else {
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        next("/workspace");
      }
    })
  } else { // pk가 없을 경우
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next("/workspace");
  }
};
function checkPjtFunction(to, from, next, res) {
  console.log('checkPjtFunction', to, from, next, res)
  
  console.log('checkPjt - 프로젝트 정보 호출 및 저장', res)
  console.log('setCurrentProject', res.data)
  store.commit('setCurrentProject', res.data)
  store.commit('setCurrentProjectTitle', res.data.name)

  // 유저 및 프로젝트 종속 정렬
  let params = {
    user: store.state.user_info.pk,
    project: store.state.current_project_pk,
  }
  http
  .get('account/get-sort-item/', { params: params, headers: { Authorization: 'Bearer ' + store.state.access_token } })
  .then(res => {
    console.log('get-sort-item res', res)
    if (!res.data.sort_json) {
      res.data.sort_json = {
        multiTableDataListOrder: '-created_at',
        isFormatMode: false,
      }
    }
    else {
      if (res.data.sort_json.multiTableDataListOrder === null || res.data.sort_json.multiTableDataListOrder === undefined) {
        res.data.sort_json.multiTableDataListOrder = '-created_at'
      }
      if (res.data.sort_json.isFormatMode === null || res.data.sort_json.isFormatMode === undefined) {
        res.data.sort_json.isFormatMode = false
      }
    }
    store.commit('setCurrentProjectSort', res.data.sort_json)
  })

  // 프로젝트 진입 시 메뉴 권한(표시)에 따른 메뉴 이동
  let menu = ''
  if (to.name === 'RpaList') {
    menu = 'rpa'
  }
  else if (to.name === 'RpaList2') {
    menu = 'rpa2'
  }
  else if (to.path.includes('rpa2')) {
    menu = 'rpa2'
  }
  else if (to.path.includes('rpa')) {
    menu = 'rpa'
  }
  else if (to.path.includes('ai-agent')) {
    menu = 'ai-engine'
  }
  else if (to.path.includes('timeline')) {
    menu = 'dashboard'
  }
  else if (to.path.includes('form')) {
    menu = 'estimate'
  }
  else if (to.name === 'InsightList') {
    menu = 'insight'
  }
  else {
    menu = to.path.split('/')[1]
  }
  console.log('menu', menu)

  // 메뉴 권한과 관련 없음
  // 커스텀, 프로젝트 휴지통, 프로젝트 관리, 언어 관리, 통합 결과
  if (
    to.name.includes('Custom') || 
    to.name.includes('ProjectTrashCan') || 
    to.name.includes('ProjectManagement') || 
    to.path.includes('rpa-terminology') || 
    to.path.includes('rpa-total-result')
  ) {
    next();
  }
  else {
    // 오너 이거나 프로젝트 메뉴 권한이 존재하지 않을(공유 받은 프로젝트가 아닌) 경우 -> 본인 조직 메뉴 권한 체크
    if (
      store.state.current_project.level === 4 || 
      ( !store.state.current_project.menu_permission || (store.state.current_project.menu_permission && !store.state.current_project.menu_permission.length) )
    ) {
      // 본인 조직 메뉴 권한 > 해당 메뉴가 활성화된 경우
      if (store.state.user_info.menu_permission[menu]) {
        next();
      }
      else {
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>메뉴 권한이 없습니다.(1)<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        next("/workspace");
      }
    }

    // 프로젝트 메뉴 권한이 존재할(공유 받은 프로젝트인) 경우
    // 본인 조직 메뉴 권한 체크 후 프로젝트 메뉴 권한 체크
    else {
      // 본인 조직 메뉴 권한 > 해당 메뉴가 활성화된 경우
      if (store.state.user_info.menu_permission[menu]) {
        // 개인으로 초대 받은 프로젝트인 경우 -> 프로젝트 메뉴 권한 중 본인의 메뉴 권한 체크
        let user_invite_list = store.state.current_project.menu_permission.filter(v => v.type === 'organization_user' && v.id === store.state.user_info.pk)
        if (user_invite_list.length > 0) {
          // 프로젝트 메뉴 권한 중 본인의 메뉴 권한 > 해당 메뉴가 활성화된 경우
          if (user_invite_list[0].menu_permission[menu]) {
            next();
          }
          // else {
          //   Swal.mixin({
          //     toast: true,
          //     showClass: { popup: 'animate__animated animate__fadeInDown' },
          //     hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          //     position: 'top',
          //     showConfirmButton: false,
          //     timer: store.getters.toastTimer,
          //     timerProgressBar: false,
          //     didOpen: (toast) => {
          //       toast.addEventListener('mouseenter', Swal.stopTimer)
          //       toast.addEventListener('mouseleave', Swal.resumeTimer)
          //     }
          //   }).fire({
          //     icon: "warning",
          //     iconColor: "#ffc107",
          //     title: "<div style='font-size: 16px; color: #0D0E17'>메뉴 권한이 없습니다.(2)<div>",
          //     width: store.getters.toastWidth,
          //     background: store.getters.toastBgColor
          //   })
          //   next("/workspace");
          // }
        }
        // 조직으로 초대 받은 프로젝트인 경우 -> 프로젝트 메뉴 권한 중 본인 조직 혹은 부모 조직의 메뉴 권한 체크
        // 프로젝트 메뉴 권한 중 본인 조직의 메뉴 권한 체크
        let organization_sub_invite_list = store.state.current_project.menu_permission.filter(v => v.type === 'organization' && v.id === store.state.user_info.organization_sub)
        if (organization_sub_invite_list.length > 0) {
          if (organization_sub_invite_list[0].menu_permission[menu]) { // 해당 메뉴 활성화 시
            next();
          }
          // else {
          //   Swal.mixin({
          //     toast: true,
          //     showClass: { popup: 'animate__animated animate__fadeInDown' },
          //     hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          //     position: 'top',
          //     showConfirmButton: false,
          //     timer: store.getters.toastTimer,
          //     timerProgressBar: false,
          //     didOpen: (toast) => {
          //       toast.addEventListener('mouseenter', Swal.stopTimer)
          //       toast.addEventListener('mouseleave', Swal.resumeTimer)
          //     }
          //   }).fire({
          //     icon: "warning",
          //     iconColor: "#ffc107",
          //     title: "<div style='font-size: 16px; color: #0D0E17'>메뉴 권한이 없습니다.(3)<div>",
          //     width: store.getters.toastWidth,
          //     background: store.getters.toastBgColor
          //   })
          //   next("/workspace");
          // }
        }
        // 프로젝트 메뉴 권한 중 부모 조직들의 메뉴 권한 체크
        let organization_tree_invite_list_cnt = 0
        if (store.state.user_info.organization_tree && store.state.user_info.organization_tree.length > 0) {
          for (let organization_tree_pk of store.state.user_info.organization_tree) {
            let organization_tree_invite_list = store.state.current_project.menu_permission.filter(v => v.type === 'organization' && v.id === organization_tree_pk)
            if (organization_tree_invite_list.length > 0) {
              organization_tree_invite_list_cnt += 1
              if (organization_tree_invite_list[0].menu_permission[menu]) {
                next();
              }
              // else {
              //   Swal.mixin({
              //     toast: true,
              //     showClass: { popup: 'animate__animated animate__fadeInDown' },
              //     hideClass: { popup: 'animate__animated animate__fadeOutUp' },
              //     position: 'top',
              //     showConfirmButton: false,
              //     timer: store.getters.toastTimer,
              //     timerProgressBar: false,
              //     didOpen: (toast) => {
              //       toast.addEventListener('mouseenter', Swal.stopTimer)
              //       toast.addEventListener('mouseleave', Swal.resumeTimer)
              //     }
              //   }).fire({
              //     icon: "warning",
              //     iconColor: "#ffc107",
              //     title: "<div style='font-size: 16px; color: #0D0E17'>메뉴 권한이 없습니다.(4)<div>",
              //     width: store.getters.toastWidth,
              //     background: store.getters.toastBgColor
              //   })
              //   next("/workspace");
              // }
            }
          }
        }

        // 예외 처리 - 과거에 공유 받은 프로젝트인 경우 프로젝트 메뉴 권한에 본인 조직의 정보가 없음 -> 본인 조직 메뉴 권한 체크
        if (user_invite_list.length === 0 && organization_sub_invite_list.length === 0 && organization_tree_invite_list_cnt === 0) {
          console.log('예외 처리 - 과거에 공유 받은 프로젝트인 경우 프로젝트 메뉴 권한에 본인 조직의 정보가 없음 -> 본인 조직 메뉴 권한 체크')
          if (store.state.user_info.menu_permission[menu]) {
            next();
          }
          else {
            Swal.mixin({
              toast: true,
              showClass: { popup: 'animate__animated animate__fadeInDown' },
              hideClass: { popup: 'animate__animated animate__fadeOutUp' },
              position: 'top',
              showConfirmButton: false,
              timer: store.getters.toastTimer,
              timerProgressBar: false,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            }).fire({
              icon: "warning",
              iconColor: "#ffc107",
              title: "<div style='font-size: 16px; color: #0D0E17'>메뉴 권한이 없습니다.(5)<div>",
              width: store.getters.toastWidth,
              background: store.getters.toastBgColor
            })
            next("/workspace");
          }
        }
      }
      else {
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>메뉴 권한이 없습니다.(6)<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        next("/workspace");
      }
    }
  }
}

const checkRpa = (to, from, next) => {
  console.log('checkRpa', to, from, next)
  if ('rpa_pk' in to.params) {
    // rpa 정보 호출 및 저장
    http
    .get(`annotation/rpa-item/${Number(to.params.rpa_pk)}/`, { headers: { Authorization: 'Bearer ' + store.state.access_token } })
    .then(res => {
      console.log('getRpaItem res', res)
      if (res.data) {
        let copied_data = JSON.parse(JSON.stringify(res.data))
        copied_data.rpa = null
        console.log('setCurrentRpa', copied_data)
        store.commit('setCurrentRpa', copied_data)
        next();
      } else {
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        next("/workspace");
      }
    })
    .catch(err => {
      console.log(err)
      console.log(err.response)
      if (err.response && err.response.status === 401) { // access token 만료
        methodRecall()
        .then(msg => {
          console.log(msg)
          // method 재호출
          http
          .get(`annotation/rpa-item/${Number(to.params.rpa_pk)}/`, { headers: { Authorization: 'Bearer ' + store.state.access_token } })
          .then(res => {
            console.log('getRpaItem res', res)
            if (res.data) {
              let copied_data = JSON.parse(JSON.stringify(res.data))
              copied_data.rpa = null
              console.log('setCurrentRpa', copied_data)
              store.commit('setCurrentRpa', copied_data)
            }
          })
        })
        .catch(err_msg => {
          console.log(err_msg)
          store.commit('setOverlay', false)
          store.commit('setOverlayText', '')
          if (err_msg === 0) {
            console.log('BE에 access token 저장 실패')
          } else { // err_msg === 1
            console.log('refresh token 만료(access token 갱신 실패)')
            // store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
            store.commit('logout')
            next('/');
          }
        })
      } else {
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        next("/workspace");
      }
    })
  } else { // rpa_pk가 없을 경우
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next("/workspace");
  }
};

const routes = [
  // 랜딩페이지
  { path: "/", name: "LandingPage",
    component: () => import("../views/LandingPage.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 로그인(대검 전용)
  // { path: "/", name: "LoginProsecution",
  //   component: () => import("../views/LoginProsecution.vue"),
  //   beforeEnter: multiguard([redirectWorkspace]),
  // },
  // 회원가입(대검 전용)
  // { path: "/sign-up-prosecution", name: "SignUpProsecution",
  //   component: () => import("../views/SignUpProsecution.vue"),
  //   beforeEnter: multiguard([onlyBeforeLogin]),
  // },

  // 랜딩페이지 > 제품 > 워크플로우
  { path: "/product-workflow", name: "ProductWorkflow",
    component: () => import("../views/ProductWorkflow.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 엑셀 서식
  { path: "/product-excel-format", name: "ProductExcelFormat",
    component: () => import("../views/ProductExcelFormat.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 데이터 검증
  { path: "/product-data-verify", name: "ProductDataVerify",
    component: () => import("../views/ProductDataVerify.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 문서 폼
  { path: "/product-document-form", name: "ProductDocumentForm",
    component: () => import("../views/ProductDocumentForm.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 이메일 유효성 검증
  { path: "/product-email-verify", name: "ProductEmailVerify",
    component: () => import("../views/ProductEmailVerify.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 협업 기능
  { path: "/product-cooperation", name: "ProductCooperation",
    component: () => import("../views/ProductCooperation.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 시각화 대시보드
  { path: "/product-visualization", name: "ProductVisualization",
    component: () => import("../views/ProductVisualization.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 솔루션 > 이커머스
  { path: "/solution-ecommerce", name: "SolutionEcommerce",
    component: () => import("../views/SolutionEcommerce.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 솔루션 > 유통 ∙ 물류
  { path: "/solution-logistics", name: "SolutionLogistics",
    component: () => import("../views/SolutionLogistics.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 솔루션 > 리테일
  { path: "/solution-retail", name: "SolutionRetail",
    component: () => import("../views/SolutionRetail.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 고객사례
  { path: "/customer-example", name: "CustomerExample",
    component: () => import("../views/CustomerExample.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 고객사례 > 세부 페이지
  { path: "/customer-example/:idx", name: "CustomerExampleDetail",
    component: () => import("../views/CustomerExampleDetail.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 플랜안내
  // { path: "/plan-guide", name: "PlanGuide",
  //   component: () => import("../views/PlanGuide.vue"),
  //   beforeEnter: multiguard([redirectWorkspace]),
  // },
  // 랜딩페이지 > 바우처
  // { path: "/voucher", name: "Voucher",
  //   component: () => import("../views/Voucher.vue"),
  //   beforeEnter: multiguard([redirectWorkspace]),
  // },
  // 랜딩페이지 > 뉴스룸
  { path: "/news-room", name: "NewsRoom",
    component: () => import("../views/NewsRoom.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 뉴스룸 > 세부 페이지
  { path: "/news-room/:idx", name: "NewsRoomDetail",
    component: () => import("../views/NewsRoomDetail.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 도입 문의하기
  { path: "/contact", name: "Contact",
    component: () => import("../views/Contact.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 소개서 받아보기
  { path: "/manual-download", name: "ManualDownload",
    component: () => import("../views/ManualDownload.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },

  // 회원가입(개인)
  { path: "/sign-up", name: "SignUp",
    component: () => import("../views/SignUp.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },
  // 회원가입(기업)
  { path: "/sign-up-corporate", name: "SignUpCorporation",
    component: () => import("../views/SignUpCorporation.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },
  // 회원가입(기업)
  { path: "/sign-up-corporate2", name: "SignUpCorporation",
    component: () => import("../views/SignUpCorporation.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },
  // 이메일 인증
  { path: "/email-confirm/:uidb64/:token", name: "EmailConfirm",
    component: () => import("../views/EmailConfirm.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },
  // 비밀번호 변경
  { path: "/reset-password-confirm/:uidb64/:token", name: "ResetPasswordConfirm",
    component: () => import("../views/ResetPasswordConfirm.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },

  // 워크스페이스
  { path: "/workspace", name: "WorkSpace",
    component: () => import("../views/WorkSpace.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  // 태그 관리
  { path: "/tag-management", name: "TagManagement",
    component: () => import("../views/TagManagement.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  // 전체 AI Agent 목록
  { path: "/total-ai-agent-list", name: "TotalAiAgentList",
    component: () => import("../views/TotalAiAgentList.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },

  // 팀 관리
  { path: "/team-management", name: "TeamManagement",
    component: () => import("../views/TeamManagement.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  // 내 휴지통
  { path: "/total-trash-can", name: "TotalTrashCan",
    component: () => import("../views/TotalTrashCan.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  // 어드민 메뉴
  { path: "/admin-menu", name: "AdminMenu",
    component: () => import("../views/AdminMenu.vue"),
    beforeEnter: multiguard([onlyAfterLogin, onlySuperAdmin]),
  },

  // 타임라인
  { path: "/dashboard/:pk", name: "DashBoard",
    component: () => import("../views/TimeLine.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 데이터
  { path: "/data-management/:pk", name: "DataManagement",
    component: () => import("../views/Data.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 프로세스 분석
  { path: "/process/:pk", name: "Process",
    component: () => import("../views/Process.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 언어 관리
  { path: "/rpa-terminology/:pk", name: "RpaTerminology",
    component: () => import("../views/Rpa/RpaTerminology.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 통합 결과
  { path: "/rpa-total-result/:pk", name: "RpaTotalResult",
    component: () => import("../views/Rpa/RpaTotalResult.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 워크플로우 목록
  { path: "/rpa-list2/:pk", name: "RpaList2",
    component: () => import("../views/Rpa/RpaList2.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 워크플로우
  { path: "/rpa2/:pk/:rpa_pk", name: "RpaMain2",
    component: () => import("../views/Rpa/RpaMain2.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt, checkRpa]),
  },
  // 워크플로우 (new)
  { path: "/rpa3/:pk/:rpa_pk", name: "RpaMain3",
    component: () => import("../views/Rpa/RpaMain3.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt, checkRpa]),
  },

  // 견적서
  { path: "/estimate/:pk", name: "Estimate",
    component: () => import("../views/Estimate.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 문서 폼 (템플릿 목록)
  { path: "/form-list/:pk", name: "FormList",
    component: () => import("../views/FormList.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 문서 폼 (템플릿(문서 목록))
  { path: "/form/:pk/:form_pk", name: "Form",
    component: () => import("../views/Form.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 테이블
  { path: "/table/:pk", name: "Table",
    component: () => import("../views/Table.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 인사이트 목록
  { path: "/insight-list/:pk", name: "InsightList",
    component: () => import("../views/InsightList.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 인사이트
  { path: "/insight/:pk/:insight_pk?", name: "Insight",
    component: () => import("../views/Insight.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // AI Agent
  { path: "/ai-agent/:pk", name: "AiAgent",
    component: () => import("../views/AiAgent.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 비동기 작업 로그
  { path: "/ai-agent/:pk/:async_task_pk", name: "AsyncTaskLogDetail",
    component: () => import("../views/AsyncTaskLogDetail.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 이메일 검증
  { path: "/email-verify/:pk", name: "EmailVerify",
    component: () => import("../views/EmailVerify.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 표 검출
  { path: "/table-detection/:pk", name: "TableDetection",
    component: () => import("../views/TableDetection.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 검출 결과
  { path: "/detection-result/:pk", name: "DetectionResult",
    component: () => import("../views/Data.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // Inner DB
  { path: "/inner-db/:pk", name: "InnerDb",
    component: () => import("../views/InnerDb.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // OCR
  { path: "/ocr/:pk", name: "Ocr",
    component: () => import("../views/Ocr.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // PDF 분류
  { path: "/pdf-classification/:pk", name: "PdfClassification",
    component: () => import("../views/PdfClassification.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 커스텀
  { path: "/custom/:pk", name: "Custom",
    component: () => import("../views/Custom.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // MOU 리스트
  { path: "/mou-list/:pk", name: "MouList",
    component: () => import("../views/MouList.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 법인판매현황
  { path: "/corporate-sales-status/:pk", name: "CorporateSalesStatus",
    component: () => import("../views/CorporateSalesStatus.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // IROS 검색
  { path: "/iros-search/:pk", name: "IrosSearch",
    component: () => import("../views/IrosSearch.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  
  // 정보추출
  { path: "/extraction/:pk/:level", name: "Extraction",
    component: () => import("../views/Extraction.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 키워드
  { path: "/keyword/:pk/:level", name: "Keyword",
    component: () => import("../views/Keyword.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 요약
  { path: "/summary/:pk/:level", name: "Summary",
    component: () => import("../views/Summary.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 텍스트 분석
  { path: "/scatter", name: "Scatter",
    component: () => import("../views/Scatter.vue"),
    beforeEnter: multiguard([]),
  },

  // 데이터 그룹화
  { path: "/data-grouping/:pk", name: "DataGrouping",
    component: () => import("../views/DataGrouping.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 프로젝트 휴지통
  { path: "/project-trash-can/:pk", name: "ProjectTrashCan",
    component: () => import("../views/ProjectTrashCan.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 프로젝트 관리
  { path: "/project-management/:pk", name: "ProjectManagement",
    component: () => import("../views/ProjectManagement.vue"),
    beforeEnter: multiguard([onlyAfterLogin, onlyOwner, checkPjt]),
  },

  // 개인정보 처리방침
  { path: "/privacy-policy", name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
  },
  // 이용약관
  { path: "/terms", name: "Terms",
    component: () => import("../views/Terms.vue"),
  },

  // page-not-found
  { path: "/page-not-found", name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
  { path: "*", redirect: "/page-not-found",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // 라우트가 변경되기 직전에 현재 열려있는 Swal을 모두 닫음
  Swal.close();

  // JWT 토큰 디코딩 및 만료 확인
  const isRefreshTokenExpired = (token) => {
    // console.log('isRefreshTokenExpired', token, store.state.user_info)
    if (!token) return false;
    if (!store.state.user_info || (store.state.user_info && !store.state.user_info.user_type) || (store.state.user_info && store.state.user_info.user_type === 'google')) return false

    try {
      const exp = jwtDecode(store.state.refresh_token).exp
      console.log('refresh_token exp', exp) // 초(s) 단위
      const date_now = Date.now() / 1000 // 밀리초(ms) -> 초(s) 변환
      console.log('date_now', date_now)
      const bufferTime = 5 * 60 // 5분(300초) 여유시간
      console.log('bufferTime', bufferTime)
      console.log('date_now + bufferTime - exp', date_now + bufferTime - exp)
      console.log('isRefreshTokenExpired return', date_now + bufferTime > exp)
      return date_now + bufferTime > exp;
    } catch (e) {
      console.error('Invalid token format', e);
      return false;
    }
  };

  if (isRefreshTokenExpired(store.state.refresh_token)) {
    store.commit('logout')
    next('/');
  } else {
    next();
  }
});


export default router;
